const exhibitors = [
    'Ogłoszenie firmowe',
    'Ogłoszenie prywatne',
]

export default exhibitors